import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TotpMethod } from '@freelancer/datastore/collections';
import { PromptTwoFaAlternativesGetResultAjax } from '@freelancer/login-signup';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { ListItemPadding } from '@freelancer/ui/list-item';
import { TotpMethodsApi } from 'api-typings/auth/auth';

@Component({
  standalone: true,
  selector: 'app-two-factor-options',
  template: `
    <p
      class="text-small TwoFactorOptionsHeader mb-small"
      i18n="Title for 2FA options"
    >
      Choose how you want to sign in:
    </p>
    <fl-list
      [clickable]="true"
      [padding]="ListItemPadding.SMALL"
      [transparent]="true"
    >
      @if (promptTwoFaAlternatives.alternatives[TotpMethodsApi.EMAIL]) {
        <fl-list-item
          flTrackingLabel="TwoFactorOptions-Email"
          (click)="handleClick(TotpMethod.EMAIL)"
        >
          <p
            class="font-medium mb-xxsmall"
            i18n="Title for email 2FA option"
          >
            Email
          </p>
          <p
            class="mb-xsmall"
            i18n="Description for email 2FA option"
          >
            Receive a verification code through email
          </p>
        </fl-list-item>
      }
      @if (promptTwoFaAlternatives.alternatives[TotpMethodsApi.SMS]) {
        <fl-list-item
          flTrackingLabel="TwoFactorOptions-SMS"
          (click)="handleClick(TotpMethod.SMS)"
        >
          <p
            class="font-medium mb-xxsmall"
            i18n="Title for SMS 2FA option"
          >
            SMS
          </p>
          <p
            class="mb-xsmall"
            i18n="Description for SMS 2FA option"
          >
            Receive a verification code through SMS
          </p>
        </fl-list-item>
      }
    </fl-list>
  `,
  styleUrls: ['./two-factor-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TrackingModule, UiModule],
})
export class TwoFactorOptionsComponent {
  ListItemPadding = ListItemPadding;
  TotpMethod = TotpMethod;
  TotpMethodsApi = TotpMethodsApi;

  @Input() promptTwoFaAlternatives: PromptTwoFaAlternativesGetResultAjax;

  @Output() methodChange = new EventEmitter<TotpMethod>();

  handleClick(method: TotpMethod): void {
    this.methodChange.emit(method);
  }
}
